import { render, staticRenderFns } from "./default.vue?vue&type=template&id=0fc1e8b6&scoped=true&"
import script from "./default.ts?vue&type=script&lang=ts&"
export * from "./default.ts?vue&type=script&lang=ts&"
import style0 from "./default.vue?vue&type=style&index=0&id=0fc1e8b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc1e8b6",
  null
  
)

export default component.exports